var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnEmart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F8B62D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8017 17C9.15783 17 8 15.3565 8 13.2731V11.0231C8 8.12963 9.90086 7 12.1299 7C14.8239 7 16 8.48611 16 9.97685C16 12.1481 13.812 12.6806 12.8456 12.9676C12.5675 13.0509 11.5419 13.3611 11.3094 13.4259C10.4068 13.6898 10.147 13.9861 10.147 14.3241C10.147 14.8981 10.6393 15.3981 11.7972 15.3981C12.8046 15.3981 13.5385 15.0509 13.6615 13.9815H15.7675C15.5578 15.6713 14.5595 17 11.8017 17ZM12.0433 8.61111C10.8718 8.61111 10.106 9.40741 10.106 10.7593V12.1806C10.106 12.1806 11.6877 11.713 12.3487 11.5093C12.9003 11.338 13.894 10.9815 13.894 10.0926C13.894 9.31944 13.2786 8.61111 12.0433 8.61111Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnEmart);
export default __webpack_public_path__ + "static/media/unEmart.4b6abcdd2dd8ed0f9b3c433603722d3c.svg";
export { ForwardRef as ReactComponent };